import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorListRow } from "web_myplann/Calculators/Components/CalculatorListRow";
import type { CalculatorAccessMap } from "web_myplann/Calculators/Types/CalculatorAccess";
import type { CalculatorSection } from "web_myplann/Calculators/Types/CalculatorSection";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";

type Props = {
	section: CalculatorSection;
	access: CalculatorAccessMap;
	onSelect: (type: CalculatorType) => void;
	onUnavailableSelect: (type: CalculatorType) => void;
};

export const CalculatorListSection: FC<Props> = ({
	section,
	access,
	onSelect,
	onUnavailableSelect,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const types = section.types.filter((type) => access[type].isVisible);

	if (types.length === 0) {
		return null;
	}

	return (
		<>
			<SectionHeader title={t(Resources.Calculators.Sections[section.key])} />
			<Stack bgcolor={theme.palette.background.paper}>
				{types.map((type, index) => (
					<CalculatorListRow
						key={type}
						type={type}
						isLast={index === types.length - 1}
						isEnabled={access[type].hasAccess}
						onClick={() =>
							access[type].hasAccess
								? onSelect(type)
								: onUnavailableSelect(type)
						}
					/>
				))}
			</Stack>
		</>
	);
};
